import '.an{position:relative;}.ssr-plugin'
import '.es{appearance:none;}.ssr-plugin'
import '.ah{flex-shrink:0;}.ssr-plugin'
import '.et{width:1.5rem;}.ssr-plugin'
import '.eu{height:1.5rem;}.ssr-plugin'
import '.gv{border-radius:2.125rem;}.ssr-plugin'
import '.ew{border:2px solid var(--gray-200);}.ssr-plugin'
import '.dr{background:var(--palette-white);}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.a6{font-style:normal;}.ssr-plugin'
import '.a5{font-weight:400;}.ssr-plugin'
import '.e2{user-select:none;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import { styled } from 'inlines'
import { useId } from 'react'
import { Icon } from '../icon/Icon'
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons'
import { Tooltip } from '../tooltip/Tooltip'

export type RadioButtonProps = {
  selected: boolean
  groupName?: string
  label?: string
  labelPosition?: 'right' | 'left'
  labelSize?: 'medium' | 'small'
  disabled?: boolean
  style?: React.CSSProperties
  onClick: () => void
  tooltipText?: string
}

export const RadioButton = ({
  selected,
  groupName,
  label,
  labelPosition = 'right',
  labelSize = 'medium',
  disabled = false,
  style,
  tooltipText,
  onClick,
}: RadioButtonProps) => {
  const id = useId()
  const handler = () => {
    if (!disabled) {
      onClick()
    }
  }

  const input = (
    <styled.input className="an es ah et eu gv ew dr"
      key="input-label"
      id={id}
      name={groupName || ''}
      checked={selected}
      type="radio"
      disabled={disabled}
      onChange={handler}
      style={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        '&:hover': {
          border: '2px solid var(--gray-300)',
        },
        '&:checked': {
          background: 'radial-gradient(circle at center, white 0.25rem, var(--brand-primary) 0.25rem)',
          border: '2px solid var(--brand-primary)',
          animation: 'radio-button-checked 0.2s ease-out',
        },
        '&:disabled': {
          background: 'var(--gray-100)',
          border: '2px solid var(--gray-200)',
        },
        '&:checked:disabled': {
          background: 'radial-gradient(circle at center, white 0.25rem, var(--palette-blue-100) 0.25rem)',
          border: '2px solid var(--palette-blue-100)',
          animation: 'radio-button-checked 0.2s ease-out',
        },

      }}
    />
  )

  const labelComponent = <styled.div key="radio-label">{label}</styled.div>
  const components = !label
    ? input
    : labelPosition === 'right'
      ? [input, labelComponent]
      : [labelComponent, input]

  return (
    <styled.label className="d r a6 a5 e2"
      htmlFor={id}
      style={{
        fontSize: labelSize === 'medium' ? '1.5rem' : '1.125rem',
        cursor: disabled ? 'not-allowed' : 'pointer',
        ...style,
      }}
    >
      <div className="d r s">
        {components}
      </div>
      {tooltipText && (
        <styled.span
        onClick={(e: React.MouseEvent) => {
          e.preventDefault()
          e.stopPropagation()
        }}>
          <Tooltip content={tooltipText}>
            <Icon 
              icon={faCircleInfo} 
              style={{ 
                color: 'var(--palette-blue-200)',
                '&:hover': { color: 'var(--brand-secondary)' },
                '&:focus-visible': { color: 'var(--brand-secondary)' }, 
              }} 
              size="small"
            />
          </Tooltip>
        </styled.span>
      )}
    </styled.label>
  )
}
